import { z } from 'zod'

/** 企業帳號 - 所有權限項目 Schema */
export const corporateAccountAllPermissionsSchema = z.object({
  /** 異業合作 */
  unitCrossIndCoop: z.boolean(),
  /** 購物車 */
  unitShoppingCart: z.boolean(),
  /** 我的帳號 */
  unitMyAcct: z.boolean(),
  /** 點數明細查詢 */
  giftPointDetail: z.boolean(),
  /** 禮遇兌換 */
  giftCourtesyExchange: z.boolean(),
  /** 指派禮遇 */
  giftCourtesyAssign: z.boolean(),
  /** 名單管理 */
  employeeList: z.boolean(),
  /** 寄送邀請信 */
  employeeSendInvitation: z.boolean(),
  /** 已寄送邀請信記錄 */
  employeeInvitationHistory: z.boolean(),
  /** 本次合約期間開票總金額 */
  tvlAmountCurrent: z.boolean(),
  /** 歷史區間查詢 */
  tvlAmountHistory: z.boolean(),
  /** 各檻次介紹 */
  tvlAmountThold: z.boolean()
})

/** 企業帳號 - 所有權限項目 */
export interface CorporateAccountAllPermissions
  extends z.infer<typeof corporateAccountAllPermissionsSchema> {}
